import { defineStore } from 'pinia';
import axios from 'axios';

export const useUserStore = defineStore('store.user', {
	state: () => ({
		authenticated: false,
		user: {
			subscription: null,
			read_subscription: null,
			company_selection_required: false,
			companies: [] as any[],
		},
		userProxy: {},
		userProxyId: '',
		token: '',
	}),
	getters: {

	},
	actions: {
		async setUserProxyId(hash: any) {
			if (hash == null) {
				delete axios.defaults.headers.common['X-USER-PROXY-ID'];
				this.userProxyId = '';
				this.userProxy = {};
			} else {
				try {
					this.userProxyId = hash;
					axios.defaults.headers.common['X-USER-PROXY-ID'] = hash;
					const request = await axios.get('/user');
					const { data } = request;
					this.userProxy = data;
				} catch (error) {
					console.log(error)
				}
			}
		},
		setToken(token: any) {
			this.token = token;
		},
		setUser(user: any) {
			this.user = user;
		},
		setAuthenticated(value: boolean) {
			this.authenticated = value;
		},
	},
});
